module.exports = __webpack_public_path__ + "static/media/cartaconducao.b3ddfc70.jpg";